export default "__VITE_ASSET__tc98zQ$W__"